export const plural = (number, words) => {
    return Math.abs(parseInt(number, 10)) === 1 ? words[0] : words[1];
};

export const locale = {
    //staticConfigsLoader
    "StaticConfigLoader.caption.error": "初始化错误",
    "StaticConfigLoader.caption.init": "初始化",
    "StaticConfigLoader.text.init": "正在初始化应用程序…",
    "StaticConfigLoader.error.settings": "无法加载网站设置",
    "StaticConfigLoader.error.circuits": "无法加载服务配置",
    //app
    "Legal.Localization": "zh",
    "AchievementApp.Navbar.storeTitle": "商店",
    "AchievementApp.Navbar.supportTitle": "支持",
    "Legal.TermsConditions": "条款与条件",
    "Legal.TermsService": "服务条款",
    "Legal.PrivacyPolicy": "隐私政策",
    "Legal.CookiesPolicy": "Cookie 设置",
    "Legal.Copyright": "所有商标，标识及品名均为其各自所有者的财产。",
    "AchievementApp.Navbar.achievement": "个人成就",
    "AchievementApp.Navbar.userAchievement": "用户成就",
    "AchievementApp.Navbar.settingsLink": "设置",
    "AchievementApp.Navbar.profileLink": "档案",
    "AchievementApp.Navbar.reloginLink": "重新登录或更改帐户",
    "AchievementApp.Navbar.pageTitlePrew": "",
    "AchievementApp.Navbar.pageTitle": "aijin.Net 成就",
    //commonAssets
    "ViewItemDetailed.state.completed": "已达成",
    //marketAppFilterEditor
    "AppFilterEditor.label.byTitles": "按标题筛选",
    //userFriendsList
    "UserFriendsList.heading.myFriends": "我的好友",
    "UserFriendsList.heading.showMore": "显示更多",
    //credentialsIcon
    "LimitedAccountPanel.2step.reason": "你需要设置双重验证",
    "LimitedAccountPanel.2step.link": "有关双重验证的更多信息",
    "LimitedAccountPanel.2step.href": "https://support.gaijin.net/hc/en-us/articles/203623622-How-to-set-up-the-Two-Step-Authorization-Google-Authenticator-",
    "LimitedAccountPanel.email.reason": "你需要确认电子邮件地址",
    "LimitedAccountPanel.email.link": "前往档案",
    "LimitedAccountPanel.email.href": "https://store.gaijin.net/user.php",
    "LimitedAccountPanel.title": "你的帐户受到限制，原因为：",
    "LimitedAccountPanel.conclusion": "更改安全设置后，应该退出并重新登录以使更改生效",
    "LimitedAccountPanel.relogin": "重新登录",
    "EmailVerificationStateIcon.success": "帐户已确认，电子邮件已验证",
    "EmailVerificationStateIcon.warning": "帐户未确认，电子邮件未验证",
    "EmailVerificationStateIcon.danger": "帐户未确认，电子邮件需要验证",
    "TwoFactorStateIcon.success": "帐户已安全进行双重验证",
    "TwoFactorStateIcon.warning": "不安全帐户，双重验证已禁用",
    "TwoFactorStateIcon.danger": "需要双重验证",
    //userSettingsDialog
    "UserSettingDialog.saveSettings": "保存设置",
    "UserSettingDialog.settings": "设置",
    "UserSettingDialog.userSettings": "用户设置",
    "UserSettingDialog.language": "语言",
    "UserSettingDialog.privacy": "隐私",
    "UserSettingDialog.allUsers": "所有用户",
    "UserSettingDialog.friendsOnly": "仅限好友",
    "UserSettingDialog.onlyMe": "仅限本人",
    "UserSettingDialog.whoCanView": "谁可以查看我的成就",
    //unlockProgress
    "ViewUnlockProgress.of": " / ",
    "ViewUnlockProgress.achievCompleted": " 个成就已达成",
    "ViewUnlockProgress.myUnlock": "我的成就",
    //userSearchFilter
    "ViewItemSearch.termsPlaceholder": "在此处搜索昵称",
    "ViewItemSearch.label.search": "搜索用户",
    "ViewItemSearch.resultNotFound": "未找到用户",
    //achievementAssets
    "ViewItemSearch.heading.resultsFor": "成就",
    "ViewItemSearch.stub.empty": "无成就",
    "ViewItemSearch.stub.emptyCompare_1": "用户 ",
    "ViewItemSearch.stub.emptyCompare_2": " 在此游戏中没有成就",
    "ViewItemSearch.limitedAccess": "对所选用户成就的访问受到限制",
    "ViewItemSearch.heading.selectGame": "从列表中选择游戏",
    "ViewItemSearch.globalstat.opened": "已有 ",
    "ViewItemSearch.globalstat.ofGamers": "% 的玩家解锁",
    //authentication
    "NotAllowedMessage.caption": "不允许",
    "NotAllowedMessage.body.h1": "成就访问权限",
    "NotAllowedMessage.body.h3": "你的帐户目前无法访问",
    "NotAllowedMessage.relogin": "更改帐户",
    "LandingMessage.caption": "验证",
    "LandingMessage.body": "正在完成着陆…",
    "TokenExpiredMessage.caption": "验证已失效",
    "TokenExpiredMessage.body.h3": "如要继续，你仍然可以",
    "TokenExpiredMessage.relogin": "重新登录",
    "AuthErrorMessage.caption": "验证失败",
    "AuthErrorMessage.body.h1": "无法检查验证",
    "AuthErrorMessage.body.code": "代码",
    "AuthErrorMessage.body.desc": "如要继续，你仍然可以",
    "AuthErrorMessage.relogin": "重新登录",
    "AuthorizationRequiredMessage.caption": "需要验证",
    "AuthorizationRequiredMessage.body.h3.1": "你即将进入",
    "AuthorizationRequiredMessage.body.h3.2": "Gaijin Achievements",
    "AuthorizationRequiredMessage.body.h3.3": "但你需要验证才能进一步进行",
    "AuthorizationRequiredMessage.login": "通过 Gaijin.Net 登录",
    "CheckingAuthMessage.caption": "验证",
    "CheckingAuthMessage.body": "正在检查验证，请耐心等待",
    "AuthorizationRequiredMessageMobile.body.h3.1": "移动版暂不可用",
    "AuthorizationRequiredMessageMobile.body.h3.2": "请使用电脑版",
    "AuthorizationRequiredMessageMobile.body.h3.3": "我们深表歉意",
}